import { IPromise, IHttpService } from "angular";

import { ICategory } from "./models";
import { EnvironmentService } from "@gtmhub/env";
import { ICollection } from "../models";

export class CategoryService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public get(categoryType: string): IPromise<ICategory[]> {
    const url = this.env.getApiEndpoint("/categories/" + categoryType);

    return this.$http.get<ICollection<ICategory>>(url).then((response) => response.data.items);
  }
}
